/**
 * Retry variables helper for Relay routes with no query variables
 * (e.g. `ProfileSettingsRoute`, `TradeRuleProposalNominatedGeneralisedRoute`).
 * Returning `{}` rather than `null` keeps the boundary retry button enabled.
 * @returns {{}} Empty variables object suitable for `loadQuery`.
 */
function getEmptyRetryVariables() {
  return {};
}

export default getEmptyRetryVariables;
